var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.178 9.37528C36.7973 2.59083 27.2027 2.59082 24.822 9.37528L20.7314 21.0327L9.15771 25.5488C2.70193 28.0679 2.70189 37.2031 9.1577 39.7222L20.7313 44.2383L24.822 55.8958C27.2027 62.6802 36.7973 62.6802 39.178 55.8958L43.2686 44.2383L54.8423 39.7222C61.2981 37.2032 61.2981 28.0679 54.8423 25.5488L43.2686 21.0327L39.178 9.37528ZM43.1005 20.9671C43.1007 20.9671 43.1008 20.9672 43.101 20.9673L43.1005 20.9671ZM43.3284 21.203L43.328 21.2017C43.3281 21.2021 43.3283 21.2026 43.3284 21.203L42.9577 21.3331L43.3284 21.203Z",
    fill: "#844E3D",
    stroke: "#84858D",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStar);
export default __webpack_public_path__ + "static/media/orangeStar.c24ea958946e2245917290b9e12dfc48.svg";
export { ForwardRef as ReactComponent };